<template>
  <div>
    <img class="pointer" style="width: 100%;" src="@/assets/financial/banner.png" @click="$login" />
    <text-left
      :text-left="{
        height: 400,
        title: '在结账期自动巡检账套并发现常见信息缺失，确保数据完整',
        desc: '通过自动巡检，筝鸣将从资产类、期末处理类、往来类、纳税调整类、以及其他类期末处理事项进行全面检测，充分提示账务处理风险，进一步确保期末结账数据的准确性。',
        textWidth: 880,
        imgWidth: 250,
        left: false,
        img: require('@/assets/financial/img3.png')
      }"/>
    <text-left
      :text-left="{
        height: 420,
        title: '业务系统类巡检',
        desc: '通过自动巡检，筝鸣还会全面检测销售、采购、费用报销、收付款、银行对账单等业务系统环节，确保银行流水与业务交易完全勾对匹配，账实相符，数据完整。',
        textWidth: 750,
        imgWidth: 270,
        left: true,
        img: require('@/assets/financial/img1.png')
      }"/>
    <text-left
      :text-left="{
        height: 450,
        title: '期初余额确认',
        desc: '财务核算是完整、连续而系统的，之前期间内任何数据上的错误都会对后期财务核算的准确性产生重大影响。自动巡检帮您在数据上把好关，一次巡检，多重保障。',
        textWidth: 720,
        imgWidth: 320,
        left: false,
        img: require('@/assets/financial/img2.png')
      }"/>
    <part-list :part-list="list" />
    <Ready />
  </div>
</template>

<script>
import Ready from '@/components/Ready'
import PartList from '@/components/PartList'
import TextLeft from '@/components/TextLeft'
export default {
  name: 'Financial',
  components: { Ready, PartList, TextLeft },
  data() {
    return {
      list: [
        {
          img: require('@/assets/common/fapiao.png'),
          title: '发票管理',
          desc: '跟踪每笔业务的发票开具或收到状态、认证和抵扣状态',
          path: '/bill'
        },
        {
          img: require('@/assets/common/xiaoshou.png'),
          title: '销售账单管控',
          desc: '跟踪销售账单收款状态，牢牢掌控应收账款',
          path: '/sale'
        },
        {
          img: require('@/assets/common/caigou.png'),
          title: '采购账单管控',
          desc: '跟踪采购账单付款状态，实现应付账款管理',
          path: '/purchase'
        },
        {
          img: require('@/assets/common/feiyong.png'),
          title: '费用报销管理',
          desc: '员工随时随地登录系统，完成费用报销申请与审批',
          path: '/reimbursement'
        },
        {
          img: require('@/assets/common/guding1.png'),
          title: '固定资产',
          desc: '集中管理，轻松维护您的固定资产',
          path: '/estate'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
